import React, {Fragment, useEffect, useRef, useState} from 'react';
import {Button, Col, Icon, Modal, Row} from 'antd';
import {FormattedMessage} from "react-intl";
import {useDrag, useDrop, DropTargetMonitor} from 'react-dnd';
import {XYCoord} from 'dnd-core';
import {WidgetItem, WidgetType} from "@models/widget";
import {VideoContentType} from "../../models/video-content";

const PropmotedCarousel: React.FC<{}> = props => {
  return (
    <Row className={`preview-wrapper`} gutter={12}>
      {props.children}
    </Row>
  )
};

const RegularCarousel: React.FC<{}> = props => {
  const [items, setItems] = useState(props.items);

  /**
   * First item add to the end of items
   */
  const onNext = () => {
    const conedItems = [...items];
    const firstItem = conedItems.splice(0, 1);
    setItems([...conedItems, ...firstItem]);
  };


  /**
   * Last item add to at the first of items
   */
  const onPrevious = () => {
    const conedItems = [...items];
    const lastItem = conedItems.pop();
    setItems([lastItem, ...conedItems]);
  };


  return (
    <div className={`preview-wrapper regular-carousel`}>
      <Icon type="left" onClick={() => onPrevious()}/>
      <Row gutter={12}>
        {items.map((item, index) => (item))}
      </Row>
      <Icon type="right" onClick={() => onNext()}/>
    </div>
  )
};

const Slider: React.FC<{}> = props => {
  const [items, setItems] = useState(props.items);

  /**
   * First item add to the end of items
   */
  const onNext = () => {
    const conedItems = [...items];
    const firstItem = conedItems.splice(0, 1);
    setItems([...conedItems, ...firstItem]);
  };


  /**
   * Last item add to at the first of items
   */
  const onPrevious = () => {
    const conedItems = [...items];
    const lastItem = conedItems.pop();
    setItems([lastItem, ...conedItems]);
  };


  return (
    <div className={`preview-wrapper slider`}>
      <Icon type="left" onClick={() => onPrevious()}/>
      <Row gutter={12}>
        {items.map((item, index) => (item))}
      </Row>
      <Icon type="right" onClick={() => onNext()}/>
    </div>
  )
};

const ArtistCarousel: React.FC<{}> = props => {
  const [items, setItems] = useState(props.items);

  /**
   * First item add to the end of items
   */
  const onNext = () => {
    const conedItems = [...items];
    const firstItem = conedItems.splice(0, 1);
    setItems([...conedItems, ...firstItem]);
  };


  /**
   * Last item add to at the first of items
   */
  const onPrevious = () => {
    const conedItems = [...items];
    const lastItem = conedItems.pop();
    setItems([lastItem, ...conedItems]);
  };


  return (
    <div className={`preview-wrapper artist-carousel`}>
      <Icon type="left" onClick={() => onPrevious()}/>
      <Row gutter={12}>
        {items.map((item, index) => (item))}
      </Row>
      <Icon type="right" onClick={() => onNext()}/>
    </div>
  )
};

const CategoryCarousel: React.FC<{}> = props => {
  const [items, setItems] = useState(props.items);

  /**
   * First item add to the end of items
   */
  const onNext = () => {
    const conedItems = [...items];
    const firstItem = conedItems.splice(0, 1);
    setItems([...conedItems, ...firstItem]);
  };


  /**
   * Last item add to at the first of items
   */
  const onPrevious = () => {
    const conedItems = [...items];
    const lastItem = conedItems.pop();
    setItems([lastItem, ...conedItems]);
  };


  return (
    <div className={`preview-wrapper category-carousel`}>
      <Icon type="left" onClick={() => onPrevious()}/>
      <Row gutter={12}>
        {items.map((item, index) => (item))}
      </Row>
      <Icon type="right" onClick={() => onNext()}/>
    </div>
  )
};

const TagCarousel: React.FC<{}> = props => {
  const [items, setItems] = useState(props.items);

  /**
   * First item add to the end of items
   */
  const onNext = () => {
    const conedItems = [...items];
    const firstItem = conedItems.splice(0, 1);
    setItems([...conedItems, ...firstItem]);
  };


  /**
   * Last item add to at the first of items
   */
  const onPrevious = () => {
    const conedItems = [...items];
    const lastItem = conedItems.pop();
    setItems([lastItem, ...conedItems]);
  };


  return (
    <div className={`preview-wrapper tag-carousel`}>
      <Icon type="left" onClick={() => onPrevious()}/>
      <Row gutter={12}>
        {items.map((item, index) => (item))}
      </Row>
      <Icon type="right" onClick={() => onNext()}/>
    </div>
  )
};

interface PreviewItemProps {
  item: WidgetType;
  id: number;
  index: number
  moveCard: (dragIndex: number, hoverIndex: number) => void
}

interface DragItem {
  index: number
  id: string
  type: string
}

const style = {
  width: '150px',
  padding: '2px',
  cursor: 'move',
  display: 'inline-block',
  margin: "0 20px 0 2px",
  textAlign: 'center'
}


export const WidgetItemPreview: React.FC<PreviewItemProps> = props => {
  const {item, type} = props;
  // dnd:
  const ref = useRef<HTMLDivElement>(null)
  const [, drop] = useDrop({
    accept: 'card',
    hover(dragItem: DragItem, monitor: DropTargetMonitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = dragItem.index;
      const hoverIndex = props.index;

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current!.getBoundingClientRect()

      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

      // Determine mouse position
      const clientOffset = monitor.getClientOffset()

      // Get pixels to the top
      const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%

      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }

      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }

      // Time to actually perform the action
      props.moveCard(dragIndex, hoverIndex);

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      dragItem.index = hoverIndex
    },
  })

  const [{isDragging}, drag] = useDrag({
    item: {type: 'card', id: props.id, index: props.index},
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  //To detect item is image or video or person or category
  const getType = () => {
    if (item.image_file) {
      return "image"
    } else if (item.video_content) {
      return "video"
    } else if (item.person) {
      return "person"
    } else if (item.category) {
      return "category"
    } else if (item.tag) {
      return "tag"
    } else if (item.channel) {
      return "liveChannel"
    } else if (item.video_file_id) {
      return "teaserVideo"
    }
  };

  const getVideoBoxColSpan = () => {
    const type = props.item.video_content ? props.item.video_content.type : null;
    switch (type) {
      case VideoContentType.SEASON:
      case VideoContentType.EPISOD:
      case VideoContentType.SERIES:
        return 6;

      case VideoContentType.CONTENT_LIST:
        return 8;

      case VideoContentType.SINGLE:
        return 4;
    }
  };

  const getImagePath = () => {
    return (
      item.image_file?.path ||
      item.poster_image_file?.path ||
      item.cover_image_file?.path ||
      item.mobile_image_file?.path ||
      item.logo_image_file?.path ||
      item.video_content?.poster_image?.path ||
      item.video_content?.thumbnail_image?.path ||
      item.poster_file?.path ||
      item.poster?.path ||
      ""
    )
  };

  /**
   * To handle video box rendering
   */
  const getVideoBox = () => {
    const image_path = getImagePath();
    return (
      //<Col span={getVideoBoxColSpan()} className={`widget-item image-box-wrapper`}>
      <div
        className={`image-box`}
        style={{backgroundImage: `url(${image_path})`}}
      >
        <div className={`image-hover-box`}>
          <div className={'image-actions-wrapper'}>
            {props.children}
          </div>
          <div className="image-box-bottom">
            <span className={`image-title`}>{item.video_content.title}</span>
          </div>
        </div>
      </div>
      //</Col>
    )
  };

  const getImageBox = () => {
    const image_file = item.image_file || {};
    return (
      //{/*<Col span={6} className={`widget-item image-box-wrapper`}>*/}
      <div
        className={`image-box`}
        style={{backgroundImage: `url(${image_file.path})`}}
      >
        <div className={`image-hover-box`}>
          <div className={'image-actions-wrapper'}>
            {props.children}
          </div>
          <div className="image-box-bottom">
            <span className={`image-title`}>{image_file.title}</span>
          </div>
        </div>
      </div>
      // </Col>
    )
  };

  const getPersonBox = () => {
    const person = item.person || {};
    const avatar = person.avatar_image ? person.avatar_image.path : null;
    return (
      //<Col span={6} className={`widget-item image-box-wrapper`}>
      <div
        className={`image-box`}
        style={{backgroundImage: `url(${avatar})`}}
      >
        {
          !avatar &&
          <Icon type="user"
                style={{fontSize: "64px", color: "beige", marginRight: "64px", marginTop: "31px"}}/>
        }
        <div className={`image-hover-box`}>
          <div className={'image-actions-wrapper'}>
            {props.children}
          </div>
          <div className="image-box-bottom">
            <span className={`image-title`}>{person.title}</span>
          </div>
        </div>
      </div>
      //</Col>
    )
  };

  const getCategoryBox = () => {
    const category = item.category || {};
    const avatar = category.thumbnail_image_file ? category.thumbnail_image_file.path : null;
    return (
      //<Col span={6} className={`widget-item image-box-wrapper`}>
      <div
        className={`image-box`}
        style={{backgroundImage: `url(${avatar})`}}
      >
        {
          !avatar &&
          <Icon type="hdd"
                style={{fontSize: "64px", color: "beige", marginRight: "64px", marginTop: "31px"}}/>
        }
        <div className={`image-hover-box`}>
          <div className={'image-actions-wrapper'}>
            {props.children}
          </div>
          <div className="image-box-bottom">
            <span className={`image-title`}>{category.title}</span>
          </div>
        </div>
      </div>
      //</Col>
    )
  };

  const getTagBox = () => {
    const tag = item.tag || {};
    const avatar = tag.thumbnail_image_file ? tag.thumbnail_image_file.path : null;
    return (
      // <Col span={6} className={`widget-item image-box-wrapper`}>
      <div
        className={`image-box`}
        style={{backgroundImage: `url(${avatar})`}}
      >
        {
          !avatar &&
          <Icon type="tag"
                style={{fontSize: "64px", color: "beige", marginRight: "64px", marginTop: "31px"}}/>
        }
        <div className={`image-hover-box`}>
          <div className={'image-actions-wrapper'}>
            {props.children}
          </div>
          <div className="image-box-bottom">
            <span className={`image-title`}>{tag.title}</span>
          </div>
        </div>
      </div>
      //</Col>
    )
  };

  const getLiveChannelBox = () => {
    const channel = item.channel || {};
    const image_path = getImagePath();
    return (
      <div className={`image-box`}  
       style={{backgroundImage: `url(${image_path})`}}>
       <div className={`image-hover-box`}>
          <div className={'image-actions-wrapper'}>
            {props.children}
          </div>
          <div className="image-box-bottom">
            <span className={`image-title`}>{channel.title}</span>
          </div>
        </div>
      </div>
    )
  };

  const getTeaserVideoBox = () => {
    const image_path = getImagePath();
    const title = item.video_file_title || item.video_file?.title || "";
    return (
      <div
        className={`image-box`}
        style={{backgroundImage: `url(${image_path})`}}
      >
        <div className={`image-hover-box`}>
          <div className={'image-actions-wrapper'}>
            {props.children}
          </div>
          <div className="image-box-bottom">
            <span className={`image-title`}>{title}</span>
          </div>
        </div>
      </div>
    )
  };

  const getEl = () => {
    const itemType = getType();
    switch (itemType) {
      case "video":
        return getVideoBox();
      case "person":
        return getPersonBox();
      case "category":
        return getCategoryBox();
      case "tag":
        return getTagBox();
      case "liveChannel":
        return getLiveChannelBox();
      case "teaserVideo":
        return getTeaserVideoBox();
      default:
        return getImageBox();
    }
  };

  return (
    <div ref={ref} style={{...style, opacity}} className={`widget-item image-box-wrapper`}>
      {getEl()}
    </div>
  )
};


interface PreviewProps {
  items: WidgetItem[];
  type: WidgetType;
}


export const WidgetPreview: React.FC<PreviewProps> = props => {
  const {type} = props;
  const [visible, setVisible] = useState(false);
  const [items, setItems] = useState(props.items);

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  const getElements = () => {
    return items.map((item, index) => (
      <WidgetItemPreview item={item} key={index}/>
    ))
  };

  const getWrapper = () => {
    switch (type) {
      case WidgetType.PROMOTED_CAROUSEL:
        return (<PropmotedCarousel items={items}>{getElements()}</PropmotedCarousel>);

      case WidgetType.REQULAR_CAROUSEL:
        return (<RegularCarousel items={getElements()}/>);

      case WidgetType.ARTIST_CAROUSEL:
        return (<ArtistCarousel items={getElements()}/>);

      case WidgetType.CATEGORY_CAROUSEL:
        return (<CategoryCarousel items={getElements()}/>);

      case WidgetType.TAG_CAROUSEL:
        return (<TagCarousel items={getElements()}/>);

      default:
        return (<Slider items={getElements()}/>);
    }
  };

  return (
    <div>
      <Button style={{float: "left"}}
              onClick={() => setVisible(true)}
              type={`primary`}>
        <FormattedMessage id="app.preview" defaultMessage={`Preview`}/>
      </Button>

      <Modal
        closable={true}
        className={'preview-modal'}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={""}
      >
        {getWrapper()}
      </Modal>
    </div>
  )

};
